import React, { useCallback, useMemo } from 'react';
import KeyboardArrowLeftIcon from '@mui/icons-material//KeyboardArrowLeft';
import SendIcon from '@mui/icons-material//Send';
import { Button, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import { InformationRequestModalAppBarProps } from './InformationRequestModalAppBar.props';
import { classes, StyledAppBar } from './InformationRequestModalAppBar.styles';

const InformationRequestModalAppBar = ({
  responsibleUserId,
  hasRequestItems,
  handleClose,
  setIsSavingModelOpen,
  hasCurrentInformationRequests,
  isSaving,
}: InformationRequestModalAppBarProps) => {
  const isButtonDisabled = useMemo(
    () => !responsibleUserId || !hasRequestItems || isSaving,
    [responsibleUserId, hasRequestItems, isSaving]
  );

  const disabledTooltip = useMemo(() => {
    if (!responsibleUserId) {
      return 'Please select a responsible user.';
    }

    if (!hasRequestItems) {
      return 'Please add at least one document or question to send.';
    }

    return '';
  }, [responsibleUserId, hasRequestItems]);

  const handleButtonClick = useCallback(() => {
    setIsSavingModelOpen(true);
  }, [setIsSavingModelOpen]);

  return (
    <StyledAppBar color="transparent" className={classes.appBar}>
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
          <KeyboardArrowLeftIcon />
        </IconButton>
        <Typography variant="h6" className={classes.title}>
          Information Request
        </Typography>
        <Tooltip title={isButtonDisabled ? disabledTooltip : ''}>
          <span>
            <Button
              autoFocus
              variant="contained"
              color="secondary"
              endIcon={<SendIcon />}
              onClick={handleButtonClick}
              disabled={isButtonDisabled}>
              {hasCurrentInformationRequests ? 'Update' : 'Send'}
            </Button>
          </span>
        </Tooltip>
      </Toolbar>
    </StyledAppBar>
  );
};

export default React.memo(InformationRequestModalAppBar);
